// 環境に応じてAPIのベースURLを設定
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost/api';